import Link from 'next/link'

import Dropdown from 'components/ui/Dropdown'
import MediaMatch from 'components/ui/MediaMatch'
import UserIcon from 'components/ui/UserIcon'
import useAuth from 'hooks/useAuth'
import helpers from 'utils/helpers'
import { routes } from 'core/const/routes'
import * as S from './styles'
import config from 'config'
import * as Analytics from 'utils/analyticsevents'

export type UserDropdownProps = {
  reduzirNomeUsuario?: boolean
}

const UserDropdown = ({ reduzirNomeUsuario }: UserDropdownProps) => {
  const { usuario, signOut } = useAuth()
  const primeiroNome = usuario?.nome && helpers.obterPrimeiroNome(usuario?.nome)

  return (
    <Dropdown
      title={
        <>
          <MediaMatch greaterThan="large">
            <div className="d-flex">
              <S.User reduzirNomeUsuario={reduzirNomeUsuario}>
                <p>
                  Olá, {''}
                  <strong>{primeiroNome}</strong>{' '}
                </p>{' '}
              </S.User>
              <UserIcon />
            </div>
          </MediaMatch>
        </>
      }
    >
      <S.Nav>
        <Link href={routes.dashboard} passHref>
          <S.Link
            onClick={() =>
              Analytics.gtmHeaderMenuUsuario({ click_text: 'Meus ambientes' })
            }
          >
            <span>Meus ambientes</span>
          </S.Link>
        </Link>
        {usuario?.perfil != config.PERFIL_EXTERNO && (
          <Link href={routes.dadosPessoais} passHref>
            <S.Link
              onClick={() =>
                Analytics.gtmHeaderMenuUsuario({ click_text: 'Dados pessoais' })
              }
            >
              <span>Dados pessoais</span>
            </S.Link>
          </Link>
        )}

        <Link href={routes.redefinirSenhaPainel} passHref>
          <S.Link
            onClick={() =>
              Analytics.gtmHeaderMenuUsuario({ click_text: 'Alterar senha' })
            }
          >
            <span>Alterar senha</span>
          </S.Link>
        </Link>
        <Link href="https://br.pinterest.com/arquitetodebolso/" passHref>
          <S.Link
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              Analytics.gtmHeaderMenuUsuario({ click_text: 'Inspire-se' })
            }
          >
            <span>Inspire-se</span>
          </S.Link>
        </Link>
        <Link href="https://api.whatsapp.com/send?phone=5511935033604" passHref>
          <S.Link
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              Analytics.gtmHeaderMenuUsuario({ click_text: 'Ajuda' })
            }
          >
            <span>Ajuda</span>
          </S.Link>
        </Link>

        <S.Link
          onClick={() => {
            Analytics.gtmHeaderMenuUsuario({ click_text: 'Sair' })
            signOut()
          }}
        >
          <span>Sair</span>
        </S.Link>
      </S.Nav>
    </Dropdown>
  )
}

export default UserDropdown
